import { AppRouteProps } from "@harea/component";
import React from "react";
import { DetailsRoutes } from "../details/DetailsRoutes";

const PaymentsList = React.lazy(() => import("./container/PaymentsList"));

export const PaymentsRoutes = [
    {
        path: "payments",
        element: <PaymentsList />,
        title: "Harea.Billing.List.Title",
        children: [
            ...DetailsRoutes
        ]
    },
] as Array<AppRouteProps>;
